<twc-icon qaid="icon_refresh-list" shape="refresh" class="refresh-icon" [ngClass]="{'grind': isRefreshing}"
    [ngClass]="{'disabled': disabled}" [twcTooltip]="'OBJECT_BROWSER.REFRESH' | translate" placement="bottom"
    (click)="onRefresh()">
</twc-icon>